module.exports = __webpack_public_path__ + "img/Sudeste.4e53894b.png";